import { LOG_OUT, REQUEST } from 'constants/actions';

export default function onLogOut() {
  return { type: LOG_OUT + REQUEST };
}
